import { render } from "./index.vue?vue&type=template&id=520877dd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=520877dd&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-520877dd"

export default script